import ApiClient from ".."

// In DTOs
import UserPostIn from "../../dtos/in/UserPostIn"
import type UserPutMeIn from "../../dtos/in/UserPutMeIn"
import UserPostMagicLinkIn from "../../dtos/in/UserPostMagicLinkIn"
import UserProcessCoachingFeasibilityIn from "../../dtos/in/UserProcessCoachingFeasibilityIn"

// Out DTOs
import type UserGetMeOut from "../../dtos/out/UserGetMeOut"
import UserPostOut from "../../dtos/out/UserPostOut"
import GenericOut from "../../dtos/out/GenericOut"
import UserPostMagicLinkOut from "../../dtos/out/UserPostMagicLinkOut"

export class UserEndpoints {
  constructor(private client: ApiClient) {}
  static readonly BASE_URL = "/user"

  /**
   * Retrieves the currently authenticated user.
   */
  async getMe() {
    return this.client.get<UserGetMeOut>(UserEndpoints.BASE_URL, "/me")
  }

  /**
   * Sends user data (i.e email and questionnnaire answers) from the coaching feasibility flow to make.com to be stored in Google Sheet
   */
  async processCoachingFeasibilityData(body: UserProcessCoachingFeasibilityIn) {
    return this.client.post<GenericOut>(UserEndpoints.BASE_URL, "/process-make-webhook", body)
  }

  /**
   * Creates a new user.
   */
  async post(body: UserPostIn) {
    return this.client.post<UserPostOut>(UserEndpoints.BASE_URL, "/", body)
  }

  /**
   * Creates a magic link for the user with the given userId.
   *
   * Can only be called by coaches for their clients, or by admins and owners for any user.
   */
  async postMagicLinkForUser(userId: number, body: UserPostMagicLinkIn) {
    return this.client.post<UserPostMagicLinkOut>(UserEndpoints.BASE_URL, `/${userId}/magic`, body)
  }

  /**
   * Upgrades the currently authenticated user for free to the next tier, if they are eligible.
   */
  async putFreeUpgrade() {
    return this.client.put<GenericOut>(UserEndpoints.BASE_URL, "/free-upgrade", null)
  }

  /**
   * Updates the currently authenticated user's data.
   */
  async putMe(payload: UserPutMeIn) {
    return this.client.put<GenericOut>(UserEndpoints.BASE_URL, "/me", payload)
  }

  /**
   * Updates the currently authenticated user's googleId to null, thus unlinking their account.
   */
  async putUnlinkGoogle() {
    return this.client.put<GenericOut>(UserEndpoints.BASE_URL, "/unlink-google", null)
  }
}
